import { updateTranslations, setLanguage, getCurrentLanguage } from './i18n.js'

// Language switcher
const langSelect = document.getElementById('languageSelect')
if (langSelect) {
  langSelect.value = getCurrentLanguage()
  langSelect.addEventListener('change', (e) => {
    setLanguage(e.target.value)
  })
  window.addEventListener('languageChanged', (e) => {
    langSelect.value = e.detail.language
  })
}

// Tab switching functionality
document.querySelectorAll('.tab-button').forEach(button => {
  button.addEventListener('click', () => {
    const tabName = button.getAttribute('data-tab')
    switchTab(tabName)
  })
})

function switchTab(tabName) {
  // Hide all tabs
  document.querySelectorAll('.tab-content').forEach(tab => {
    tab.classList.remove('active')
  })

  // Remove active class from all buttons
  document.querySelectorAll('.tab-button').forEach(btn => {
    btn.classList.remove('active')
  })

  // Show selected tab
  document.getElementById(tabName).classList.add('active')

  // Highlight selected button
  document.querySelector(`[data-tab="${tabName}"]`).classList.add('active')

  // Scroll to top of content
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

// Update translations on page load
updateTranslations()

// Listen for language changes
window.addEventListener('languageChanged', () => {
  updateTranslations()
})
